import React, { useMemo, useEffect, useState } from "react";
import { useOpticsStore } from "../../../stores/use-optics-store";
import { useAtlassianLocale } from "@Shared/Hooks/useAtlassianLocale";
import CustomEmptyState from "../../../components/empty-state/CustomEmptyState";
import { CUSTOM_EMPTY_STATE_KEY } from "../../../components/empty-state/custom-templates";
import { PaginationTypes } from "@Shared/Pagination-Types";
import { useSpacesStore } from "../../../stores/use-space-store";
import { useSpaces } from "../useSpaces";
import SpacesPreview from "../preview/SpacesPreview";

function ManualSpaces({ isEdit, mode }) {
  const [locale] = useAtlassianLocale();
  const isCosmosInstalled = useOpticsStore((state) => state.isCosmosInstalled);

  const { config, selectedTab } = useSpacesStore((state) => ({
    config: state.data.config,
    selectedTab: state.getSelectedTab(),
  }));

  const { tabs, pagination } = config || {};

  const limit = isEdit ? 999 : Number(tabs?.[selectedTab]?.limit || 4);
  const manuallyPicked = tabs?.[selectedTab]?.manuallyPicked || [];

  const spaceQueries = useSpaces(manuallyPicked, isCosmosInstalled, locale);

  const spaceResults = useMemo(
    () =>
      spaceQueries
        .map((q) => q.data)
        .filter((q) => q && !q.isPlaceholder && !q.isNew),
    [spaceQueries]
  );

  const [page, setPage] = useState(0);
  const isCarousel = pagination === PaginationTypes.CAROUSEL;
  const startIndex = isCarousel ? page * Number(limit) : 0;
  const endIndex = page * Number(limit) + Number(limit);
  const paginatedSpaces = spaceResults.slice(startIndex, endIndex);

  const queryPagination = {
    disabled: isEdit || pagination === PaginationTypes.NONE,
    hasNextPage: endIndex < spaceResults.length,
    hasPrevPage: page > 0,
    onNext: () => {
      if (endIndex < spaceResults.length) setPage((prev) => prev + 1);
    },
    onPrev: () => {
      if (page > 0) setPage((prev) => prev - 1);
    },
    page,
    setPage,
  };

  useEffect(() => setPage(0), [pagination]);

  if (!paginatedSpaces.length) {
    return <CustomEmptyState templateKey={CUSTOM_EMPTY_STATE_KEY.NEWS_SETUP} />;
  }

  const paginationData = { [isCarousel ? page : 0]: paginatedSpaces };

  return (
    <SpacesPreview
      data={paginationData}
      queryPagination={queryPagination}
      mode={mode}
    />
  );
}

export default ManualSpaces;
